module.exports = __webpack_public_path__ + "img/camera.9b8c3c51.png";